<template>
  <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading"
    >Loading ...
  </a-card>
  <a-form :form="form" v-else>
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-form-item label="Report Date">
          <a-date-picker
            placeholder="Select Date"
            :disabled="true"
            :format="getDefaultDateFormat"
            v-decorator="[
              'tanggal_pelaporan',
              {
                rules: [{ required: true }],
                initialValue: initialData.tanggal_pelaporan,
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="Approval" style="display:none">
          <a-select
            placeholder="Please select Executive"
            v-decorator="[
              'bod',
              { rules: [{ required: true }], initialValue: initialData.bod },
            ]"
            disabled
          >
            <a-select-option v-for="data in wo_bod" :key="data.value"
              >{{ data.value }} - {{ data.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "InformasiKlaimDirektur",
  props: {
    data: {},
    others: {},
    mode: String,
    type: String,
    // eslint-disable-next-line vue/require-prop-type-constructor
    active: false,
  },
  data() {
    return {
      listNoSPPD: [],
      pageLoading: true,
      pic: "",
      pic_name: "",
      bod: "",
      wo_bod: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    if (this.mode === "Create" && !this.active) {
      // this.listNoSPPD = [];
      this.bod = "ADI";
      this.fetchBodPic();
    } else {
      this.pageLoading = false;
      this.bod = "ADI";
      this.fetchBodPic();
    }

    // this.$store.dispatch("FETCH_ACTIVE_PROJECTKK");
    // axios({
    //   method: "get",
    //   url: this.$serviceUrl + "bod",
    //   params: {
    //     "X-API-KEY": this.getAuth.apikey,
    //   },
    //   auth: {
    //     username: this.getAuth.username,
    //     password: this.getAuth.password,
    //   },
    // })
    //   .then((response) => {
    //     //console.log(response);
    //     this.wo_bod = response.data.bod;
    //   })
    //   .catch((err) => {
    //     this.displayMessage("error-connection");
    //   });
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          tanggal_pelaporan: moment(),
          pic: this.pic,
          bod: this.bod,
          catatan: "",
        };
      } else {
        return {
          tanggal_pelaporan: moment(this.data.tanggal_pelaporan),
          // bod: this.data.bod ? this.data.bod : null,
          bod: this.bod,
          catatan: this.data.catatan,
        };
      }
    },
  },
  methods: {
    moment,
    fetchBodPic() {
      axios({
        method: "get",
        url: this.$serviceUrl + "klaim_direktur/approval_bod",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.wo_bod = response.data.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            if (this.mode === "Create") {
              this.$router.go(-1);
            } else {
              this.pageLoading = false;
              this.loading = false;
            }
          }
        });
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        const informasi = {
          tanggal_pelaporan: values.tanggal_pelaporan,
          bod: values.bod || "",
          catatan: this.initialData.catatan,
        };

        Event.$emit("kDirekturInformasi", informasi);
      });
    },
    beforeRouteEnter(to, from, next) {
      fetchBodPic((err, post) => {
        next();
      });
    },
    clearForm() {
      this.form.resetFields();
    },
    handleBOD(data) {
      let filter = this.wo_bod.filter(
        (obj) => obj.value.toLowerCase().indexOf(data.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style></style>
